<template>
  <div>
    <div class="modal-window mas030 bds070">
      <header class="modal-header">
        <div class="tit">
          {{ $i18nUtil.trans("message.BoardContents.003","KR 연결 추가") }}
        </div>
        <button @click="$emit('close')" class="btn_close">닫기</button>
      </header>

      <div class="modal-content">
        <div class="input-box tit">
          <input
            type="text"
            required
            maxlength="34"
            v-model="modalInfo.paperTitle"
            readonly
          />
        </div>

        <div class="info-txt">
          {{ $i18nUtil.trans("message.BoardLinkedOkr.001","나의 KR을 달성할 {groupKbnBoard}를 연결해주세요.", 
              {groupKbnBoard: modalInfo.type == "PRIV" ? $i18nUtil.trans("entity.paper.groupKbn.user","프라이빗 보드")
                            : modalInfo.type == "SHAR" ? $i18nUtil.trans("entity.paper.groupKbn.shar","정보 보드")
                            : modalInfo.type == "CFRC" ? $i18nUtil.trans("entity.paper.groupKbn.cfrc") 
                            : this.$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드")}) }}
        </div>
        <div>
          <div class="dropdown ty2 relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">{{
                  tenantId == "418502"
                    ? currentWsQrt.qrtNm
                    : $i18nUtil.getLanguage() !== 'ko' && currentQrt.QRT_TOP_MSG_EN != null ? currentQrt.QRT_TOP_MSG_EN : currentQrt.QRT_TOP_MSG
                }}</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="scroll" v-if="tenantId == '418502'">
                  <div
                    class="dropdown-list-item"
                    v-for="(item, index) in wsQrtList"
                    :key="index"
                  >
                    <div class="tit">
                      <button
                        type="button"
                        @click="qrtChange(item, $event)"
                        :class="{ active: item.qrtId == currentWsQrt.qrtId }"
                      >
                        {{ item.qrtNm }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="scroll" v-else>
                  <div
                    class="dropdown-list-item"
                    v-for="(item, index) in qrtList"
                    :key="index"
                  >
                    <div class="tit">
                      <button
                        type="button"
                        @click="qrtChange(item, $event)"
                        :class="{ active: item.QRT_CD == currentQrt.QRT_CD }"
                      >
                        {{ $i18nUtil.getLanguage() !== 'ko' && item.QRT_TOP_MSG_EN != null ? item.QRT_TOP_MSG_EN : item.QRT_TOP_MSG }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
          <div class="dropdown ty2 relative okr_linked" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss': '' ">
            <v-menu
              offset-y
              :close-on-content-click="
                tenantId == '418502' ? true : isShowLayer
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">
                  {{
                    tenantId == "418502"
                      ? currentWork.workId != undefined
                        ? currentWork.workNm
                        : $i18nUtil.trans("message.BoardLinkedOkr.007","OKR 연결 선택")
                      : currentKr.OKR_ID != undefined
                      ? currentKr.OKR_TITLE
                      : $i18nUtil.trans("message.BoardLinkedOkr.007","OKR 연결 선택")
                  }}
                </v-btn>
              </template>
              <div class="dropdown-list">
                <div class="scroll" v-if="tenantId == '418502'">
                  <div class="no-data" v-if="workList.length == 0">
                    {{ $i18nUtil.trans("message.BoardLinkedOkr.009","나의 Okr이 없습니다.") }}
                  </div>
                  <ul v-else>
                    <li
                      v-for="(item, index) in workList"
                      :key="'work' + index"
                      :class="{ active: currentWork.workId == item.workId }"
                    >
                      <button type="button" @click="selectKr(item, $event)">
                        {{ item.workNm }}
                      </button>
                    </li>
                  </ul>
                </div>
                <div class="scroll" v-else>
                  <div class="no-data" v-if="myForIndex == 0">
                    {{ $i18nUtil.trans("message.BoardLinkedOkr.009","나의 Okr이 없습니다.") }}
                  </div>
                  <ul
                    v-else
                    v-for="(item, index) in myForIndex"
                    :key="'myFor' + index"
                  >
                    <li
                      disabled
                      @mouseover="isShowLayer = false"
                      @mouseout="isShowLayer = true"
                    >
                      <button type="button" style="cursor: default">
                        {{ myOkrList[index].OKR_TITLE }}
                      </button>
                    </li>
                    <ul>
                      <li
                        :class="{ active: currentKr.OKR_ID == krItem.OKR_ID }"
                        v-for="(krItem, idx) in myKrList[index]"
                        :key="'kr' + idx"
                      >
                        <button type="button" @click="selectKr(krItem, $event)">
                          {{ krItem.OKR_TITLE }}
                        </button>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </v-menu>
          </div>
        </div>
      </div>

      <footer class="modal-footer">
        <button
          type="button"
          class="btn_ty1"
          v-if="isRegistFlag"
          @click="handlerRegistClick"
        >
          {{ $i18nUtil.trans("button.register","등록") }}
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      paperKrLinkList: [],

      startDate: "",
      endDate: "",
      /* 418502테넌트일 경우 */
      currentWsQrt: {
        qrtId: "",
        tenentCd: "",
        corpCd: "",
        qrtNm: "",
        qrtYy: "",
        qrtSttDate: "",
        qrtEndDate: "",
        okrSetSttDate: "",
        okrSetEndDate: "",
        orgchtCd: "",
        reviewSttDate: "",
        reviewEndDate: "",
        indictYn: "",
        nowQrtYn: "",
      },
      currentWork: {},
      wsQrtList: [],
      workList: [],
      /* 418502테넌트가 아닐경우 */
      currentQrt: {
        qrtCd: "",
        qrtTopMsg: "",
        qrtTopMsgEn: null,
      },
      myForIndex: 0,
      // targetForIndex: 0,
      qrtList: [],
      myOkrList: [],
      myKrList: [],
      // targetOkrList: [],
      targetKrList: [],

      currentKr: {},
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      isShowLayer: false,
      isRegistFlag: false,
    };
  },
  created() {
    this.getQrtList();
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    qrtChange(qrt, event) {
      if (this.tenantId == "418502") {
        this.currentWsQrt = qrt;
        this.currentWork = {};
        this.getOkrList(qrt.qrtId);
      } else {
        this.currentQrt = qrt;
        this.currentKr = {};
        this.getOkrList(qrt.QRT_CD);
      }
    },
    getQrtList() {
      let obj = this;
      if (this.tenantId == "418502") {
        let reqData = {
          url: "/api/copaper/okr/getQrtInfos",
          method: "post",
          req: {},
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              obj.wsQrtList = data.result;
              for (let i = 0; i < obj.wsQrtList.length; i++) {
                if (obj.wsQrtList[i].nowQrtYn == 1) {
                  obj.currentWsQrt = obj.wsQrtList[i];
                  obj.getOkrList(obj.wsQrtList[i].qrtId);
                  break;
                }
              }
            }
          })
          .catch((err) => {
            console.log("getQrtInfos error", err);
            // obj.showAlertDialog('OKR 연동에 실패했습니다.');
          });
      } else {
        let reqData = {
          url: "/api/copaper/okr/getQrtList",
          method: "post",
          req: {
            qrtCd: this.currentQrt.qrtCd,
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              obj.qrtList = data.result.qrtList;
              for (let i = 0; i < obj.qrtList.length; i++) {
                if (obj.qrtList[i].CURR_QRT_YN == 1) {
                  obj.currentQrt = obj.qrtList[i];
                  // obj.currentQrt.qrtTopMsg = obj.qrtList[i].QRT_TOP_MSG;
                  obj.getOkrList(obj.qrtList[i].QRT_CD);
                  break;
                }
              }
            }
          })
          .catch((err) => {
            console.log("getQrtList error", err);
            // obj.showAlertDialog('OKR 연동에 실패했습니다.');
          });
      }
    },
    getOkrList(qrtCode) {
      let obj = this;
      if (this.tenantId == "418502") {
        let reqData = {
          url: "/api/copaper/okr/getWorkList",
          method: "post",
          req: {
            qrtId: qrtCode,
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              obj.workList = data.result;
            }
            obj.getPaperOkrLink(qrtCode);
          })
          .catch((err) => {
            console.log("getOkrList error", err);
            // alert("getOkrList fail");
          });
      } else {
        let reqData = {
          url: "/api/cogroup/okr/getOkrList",
          method: "post",
          req: {
            qrtCd: qrtCode,
          },
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              // const targetOkr = data.result.targetOkrList;

              const myOkr = data.result.myOkrList;
              if (myOkr) {
                obj.myOkrList = [];
                obj.myKrList = [];
                let krList = [];
                for (let i = 0; i < myOkr.length; i++) {
                  if (myOkr[i].HOLD_YN == 0) {
                    if (myOkr[i].OKR_TYPE.indexOf("O") != -1) {
                      obj.myOkrList.push(myOkr[i]);
                    } else {
                      krList.push(myOkr[i]);
                    }
                  }
                }
                for (let i = 0; i < obj.myOkrList.length; i++) {
                  let krArray = [];
                  for (let j = 0; j < krList.length; j++) {
                    if (obj.myOkrList[i].OKR_ID == krList[j].PARENT_OKR_ID) {
                      krArray.push(krList[j]);
                    }
                  }
                  obj.myKrList.push(krArray);
                }
                obj.myForIndex = obj.myOkrList.length;
              }
            }
            obj.getPaperOkrLink(qrtCode);
          })
          .catch((err) => {
            console.log("getOkrList error", err);
            // alert("getOkrList fail");
          });
      }
    },
    selectKr(krItem, event) {
      if (this.tenantId == "418502") {
        this.currentWork = krItem;
      } else {
        this.currentKr = krItem;
      }

      // if (
      //   $(".dl_layer.select_ty3.okr_linked").children("dt").hasClass("active")
      // ) {
      //   $(".dl_layer.select_ty3.okr_linked")
      //     .children("dt")
      //     .removeClass("active");
      // }
    },
    changeDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const days = date.getDate();
      const currentTime =
        year.toString() +
        (month > 9 ? month : "0" + month).toString() +
        (days > 9 ? days : "0" + days).toString();
      return currentTime;
    },

    registOkrLink(type) {
      let obj = this;
      let isRegist = false;
      if (obj.tenantId == "418502") {
        if (
          obj.currentWork.workId == null ||
          obj.currentWork.workId == undefined
        ) {
          if (obj.modalInfo.type == "PRIV") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.user","프라이빗 보드")}));
          } else if (obj.modalInfo.type == "SHAR") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.shar","정보 보드")}));
          } else if (obj.modalInfo.type == "CFRC") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.cfrc","회의 보드")}));
          } else {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드")}));
          }

          return;
        }
        if (
          obj.paperKrLinkList != null &&
          obj.paperKrLinkList != undefined &&
          obj.paperKrLinkList.length > 0
        ) {
          obj.paperKrLinkList.forEach((item) => {
            if (
              obj.currentWsQrt.qrtId == item.qrtCd &&
              obj.currentWork.workId == item.okrId &&
              item.regUserId == localStorage.getItem("userId")
            ) {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB057");
              obj.showToast(obj.toastInfo);
              isRegist = true;
            }
          });
        }
      } else {
        if (obj.currentKr.OKR_ID == null || obj.currentKr.OKR_ID == undefined) {
          if (obj.modalInfo.type == "PRIV") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.user","프라이빗 보드")}));
          } else if (obj.modalInfo.type == "SHAR") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.shar","정보 보드")}));
          } else if (obj.modalInfo.type == "CFRC") {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.cfrc","회의 보드")}));
          } else {
            obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardLinkedOkr.010","{groupKbnBoard}와 연결할 KR을 먼저 선택해주세요.", {groupKbnBoard: obj.$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드")}));
          }
          return;
        }
        if (
          obj.paperKrLinkList != null &&
          obj.paperKrLinkList != undefined &&
          obj.paperKrLinkList.length > 0
        ) {
          obj.paperKrLinkList.forEach((item) => {
            if (
              obj.currentQrt.QRT_CD == item.qrtCd &&
              obj.currentKr.OKR_ID == item.okrId &&
              item.regUserId == localStorage.getItem("userId")
            ) {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB057");
              obj.showToast(obj.toastInfo);
              isRegist = true;
            }
          });
        }
      }

      if (!isRegist) {
        let params = {};
        if (this.tenantId == "418502") {
          // parentOkrId가 null인 work일 경우 toString() 오류 발생
          let parentOkrId = null;
          if (this.currentWork.parntsKrId) {
            parentOkrId = this.currentWork.parntsKrId.toString();
          }
          params = {
            paperId: this.modalInfo.paperId,
            okrTitle: this.currentWork.workNm,
            parentOkrId: parentOkrId,
            okrId: this.currentWork.workId.toString(),
            okrType: "WK",
            catId: "0",
            holdYn: "0",
            unitId: "0",
            publicYn: "0",
            levelCd: "0",
            qrtCd: this.currentWsQrt.qrtId.toString(),
            qrtTopMsg: this.currentWsQrt.qrtNm,
            okrStdDate: this.currentWork.workSttDate,
            okrEndDate: this.currentWork.workEndDate,
          };
        } else {
          params = {
            paperId: this.modalInfo.paperId,
            okrTitle: this.currentKr.OKR_TITLE,
            parentOkrId: this.currentKr.PARENT_OKR_ID,
            okrId: this.currentKr.OKR_ID.toString(),
            okrType: this.currentKr.OKR_TYPE,
            catId: this.currentKr.CAT_ID.toString(),
            holdYn: this.currentKr.HOLD_YN.toString(),
            unitId: this.currentKr.UNIT_ID,
            publicYn: this.currentKr.PUBLIC_YN,
            levelCd: this.currentKr.LEVEL_CD.toString(),
            qrtCd: this.currentQrt.QRT_CD,
            qrtTopMsg: this.currentQrt.QRT_TOP_MSG,
            qrtTopMsgEn: this.currentQrt.QRT_TOP_MSG_EN,
            okrStdDate: this.currentKr.OKR_STD_DATE,
            okrEndDate: this.currentKr.OKR_END_DATE,
          };
        }
        const reqData = {
          url: "/api/copaper/okr/setPaperOkrLink",
          method: "post",
          req: params,
        };
        obj
          .COWORK_REST_ACTION(reqData)
          .then((data) => {
            if (!data.errorCode) {
              if (obj.tenantId == "418502") {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardLinkedOkr.016","KR 연결 추가가 완료되었습니다.");
              } else {
                obj.toastInfo.message = this.$i18nUtil.trans("TB048");
              }

              obj.showToast(obj.toastInfo);
              obj.$emit("closeBoardOkrLinkPopup");
              obj.$emit("close");
            }
          })
          .catch((err) => {
            console.log("setPaperOkrLink okr연결 실패", err);
            // console.log("okr연결 실패");
          });
      }
    },
    handlerRegistClick() {
      this.registOkrLink();
    },
    /* okr 연결 목록 */
    getPaperOkrLink(qrtCd) {
      let obj = this;
      let reqData = {
        url: "/api/copaper/okr/getPaperOkrList",
        method: "post",
        params: {
          paperId: this.modalInfo.paperId,
          qrtCd: qrtCd,
        },
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          if (res.errorCode == null) {
            obj.paperKrLinkList = res.result.paperKrLinkList;
            obj.getPaperAuth();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getPaperAuth() {
      let obj = this;
      let param = {
        url: "/api/copaper/paper/getPaperAuth",
        method: "post",
        req: {
          paperId: this.modalInfo.paperId,
          checkRoleId: "NOR_BRD_WRITE:false",
        },
      };
      obj
        .COWORK_REST_ACTION(param)
        .then(function (res) {
          if (res.errorCode == null) {
            // 0: 쓰기 권한
            let paperAuthList = res.result.paperAuthList;

            obj.isRegistFlag = false;
            // 쓰기 권한 존재
            if (paperAuthList[0]["allow"]) {
              obj.isRegistFlag = true;
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    changeOkrType(type) {
      let resultType = "";
      const okrType = type.substring(0, 1);
      if (okrType == "M") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeM","개인");
      } else if (okrType == "U") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeU","유닛");
      } else if (okrType == "T") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeT","팀");
      } else if (okrType == "H") {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeH","본부");
      } else {
        resultType = this.$i18nUtil.trans("message.project.OKR.typeElse","회사");
      }
      return resultType;
    },
  },
};
</script>

<style scoped>
  .mas030 .enCss {
      width: calc(100% - 170px);
  }
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/BoardLinkedOkr.vue